import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Input,
  Output,
} from '@angular/core';
import { WindowState } from '@progress/kendo-angular-dialog';
import { CustomColumnDescriptor } from 'src/app/CommonFiles/UIModels';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { Align } from '@progress/kendo-angular-popup';

@Component({
  standalone: false,
  selector: 'app-data-selector-popup',
  templateUrl: './data-selector-popup.component.html',
  styleUrls: ['./data-selector-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataSelectorPopupComponent {
  faTimes = faTimes;
  faSearch = faSearch;
  @Input() type: string = 'popup'; // default: popup; popup, window
  data: CustomColumnDescriptor[] = [];
  dataFiltered: CustomColumnDescriptor[] = [];
  windowTop: number = 30;
  state: WindowState = 'default';
  height: number = 500;
  searchInput: string = '';
  @Input() isColumnOption: boolean;
  @Input() anchor: any;
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() checkedChangeEvent: EventEmitter<CustomColumnDescriptor[]> =
    new EventEmitter<CustomColumnDescriptor[]>();
  @Output() save: EventEmitter<CustomColumnDescriptor[]> = new EventEmitter<
    CustomColumnDescriptor[]
  >();
  @Input() public set dataArray(cc) {
    if (cc) {
      this.data = cc;

      this.dataFiltered = cc.sort((a, b) =>
        a.title.toLowerCase() > b.title.toLowerCase()
          ? 1
          : b.title.toLowerCase() > a.title.toLowerCase()
          ? -1
          : 0
      );
    }
  }

  anchorAlign = input<Align>({ horizontal: 'right', vertical: 'bottom' });
  popupAlign = input<Align>({ horizontal: 'right', vertical: 'top' });

  constructor() {}

  public checkChange(e) {
    this.dataFiltered = this.setCheckedOnColumnsConfig(
      !e.checked,
      e.field,
      this.dataFiltered
    );

    this.checkedChangeEvent.emit(this.dataFiltered);
  }

  public saveColumnsConfig() {
    this.save.emit(this.dataFiltered);
  }

  public onColumnsSearchChange(value: string): void {
    this.searchInput = value?.trim().toLowerCase();
  }

  public setCheckedForAllColumns(check: boolean) {
    this.dataFiltered = this.setCheckedOnColumnsConfig(
      check,
      undefined,
      this.dataFiltered
    );

    this.checkedChangeEvent.emit(this.dataFiltered);
  }

  onClose(e) {
    this.closeEvent.emit(e);
  }

  setCheckedOnColumnsConfig(
    checked: boolean,
    field: string = undefined,
    dataArray: CustomColumnDescriptor[]
  ) {
    dataArray.forEach((x: CustomColumnDescriptor) => {
      if (field) {
        if (field === x.field) {
          x.checked = checked;
        }
      } else {
        x.checked = checked;
      }
    });
    return dataArray;
  }
}
